export default __webpack_public_path__ + "static/media/unminting-empty-state.c9f8fe63.svg";